module.exports = "/_next/static/images/500-9b45477c30dbf0d997f18be721089b94.png";